module.exports = __webpack_public_path__ + "23de03f0eae59ab0d50d131c69b0b005.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/owlfonso-waving.png
// module id = 528
// module chunks = 0